import { all, fork } from "redux-saga/effects";
import { authorizationGateSaga } from "./authorization-gate/authorization-gate-saga";
import { applicationSaga } from "./application-saga";
import { globalSearchSaga } from "./application-wrapper/components/global-search/global-search-saga";
import { countriesSaga } from "./countries/countries-saga";
import { ncsColorsSaga } from "./ncs-colors/ncs-colors-saga";
import { ralColorsSaga } from "./ral-colors/ral-colors-saga";
import { formListItemPictureAutocompleteSaga } from "./form-list-item-picture-autocomplete/form-list-item-picture-autocomplete-saga";

export function* componentSaga() {
  yield all([fork(applicationSaga), fork(authorizationGateSaga), fork(globalSearchSaga), fork(countriesSaga), fork(ncsColorsSaga), fork(ralColorsSaga), fork(formListItemPictureAutocompleteSaga)]);
}
